export default {
    itemsAccount() {
        return this.entriesA.map(entryA => {
            return Object.assign({}, entryA, {Name: entryA.name})
        })
    }
}
